import 'react';
import { BoldHeading } from '@lendi-jam/atoms';
import Container from '@lendi-ui/container';
import Grid from '@lendi-ui/grid';
import { Body } from '@lendi-ui/typography';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleButtonTrackingEvent } from '@lendi-jam/tracking';
import { Button } from '@lendi-ui/button';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte } from '@lendi-ui/breakpoint';
import { mt, mb, ml, pt, pb, mx } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';
import { bg } from '@lendi-ui/color';

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4, _templateObject5;
var ButtonCollection = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n  ", "\n\n  ", "\n"])), mt('md'), gte('md')(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    flex-direction: row-reverse;\n  "]))));
var CenteredContent = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var ButtonContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  width: auto;\n  text-align: center;\n\n  &:first-of-type {\n    ", "\n  }\n\n  & > a {\n    display: block;\n    width: auto;\n  }\n\n  ", "\n"])), mb('xs'), gte('md')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    &:first-of-type {\n      ", "\n    }\n  "])), ml('xs')));

var Buttons = function Buttons(_ref) {
  var primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton;
  return /*#__PURE__*/jsx(CenteredContent, {
    children: /*#__PURE__*/jsxs(ButtonCollection, {
      children: [primaryButton && primaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
        children: /*#__PURE__*/jsx(Button, {
          onClick: function onClick() {
            handleButtonTrackingEvent(_objectSpread(_objectSpread({}, primaryButton), {}, {
              variant: primaryButton.variant
            }));
          },
          size: "md",
          variant: "primary",
          isFullWidth: true,
          href: embedMarketingTrackingIntoURL(primaryButton.url),
          children: primaryButton.text
        })
      }), secondaryButton && secondaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
        children: /*#__PURE__*/jsx(Button, {
          onClick: function onClick() {
            handleButtonTrackingEvent(_objectSpread(_objectSpread({}, secondaryButton), {}, {
              variant: secondaryButton.variant
            }));
          },
          size: "md",
          variant: "secondary",
          isFullWidth: true,
          href: embedMarketingTrackingIntoURL(secondaryButton.url),
          children: secondaryButton.text
        })
      })]
    })
  });
};

var _templateObject, _templateObject2, _templateObject3;
var StyledGreyBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), bg('shade.25'));
var CtaGrid = styled(Grid)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  text-align: center;\n  ", "\n"])), pt('lg'), pb('xl'), gte('xs')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    width: 100%;\n  "])), mx('nil')));

var GenericInlineCta = function GenericInlineCta(_ref) {
  var title = _ref.title,
    body = _ref.body,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton;
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsx(StyledGreyBackground, {
      children: /*#__PURE__*/jsx(CtaGrid, {
        halign: "center",
        valign: "center",
        children: /*#__PURE__*/jsxs(Grid.Unit, {
          size: {
            xs: 1,
            sm: 1,
            md: 3 / 4,
            lg: 3 / 5,
            xl: 2 / 3
          },
          children: [/*#__PURE__*/jsx(BoldHeading, {
            size: "sm",
            color: "shade.700",
            children: title
          }), body && /*#__PURE__*/jsx(Body, {
            mt: "xs",
            children: body
          }), /*#__PURE__*/jsx(Buttons, {
            primaryButton: primaryButton,
            secondaryButton: secondaryButton
          })]
        })
      })
    })
  });
};

export { GenericInlineCta as default };
